// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { HomepageExperienceCookie } from '../cookies';

angular
  .module('frontDoorPage')
  .directive(
    'startPageToggle',
    ($window, StartPageService, t, startPageTrackingService) => ({
      restrict: 'E',
      templateUrl: 'start_page/start_page_toggle.html.slim',

      scope: {
        page: '=',
        startPage: '=?',
      },

      link(scope, element, attrs) {
        const pageType = attrs.page; // "creative", "editorial", etc.
        const homepageExperienceCookie = HomepageExperienceCookie.find();

        scope.startPage =
          angular.element('#init_start_page').attr('data-switch') === 'true';
        scope.t = t;

        scope.togglePreference = function () {
          const preference = scope.startPage ? pageType : 'homepage';
          scope.setStartPagePreference(preference);
          togglePreferenceTracking();
          return true;
        };

        // if user is logged in, we also set their preference on the UserPreferences table
        // we always set the preference in the cookie, regardless of logged in state
        scope.setStartPagePreference = function (preference) {
          if ($window.user.isAuthenticated) {
            StartPageService.setStartPagePreference(preference);
          }

          homepageExperienceCookie.value = preference;
        };

        var togglePreferenceTracking = function () {
          let eventName;
          if (scope.startPage) {
            eventName = 'SettingLandingPage-ToggleOn';
          } else {
            eventName = 'SettingLandingPage-ToggleOff';
          }
          startPageTrackingService.sendEvent(eventName, 'event192');
        };

        return;
      },
    })
  );
